import { render } from "./Nopassword.vue?vue&type=template&id=4cca8006"
import script from "./Nopassword.vue?vue&type=script&lang=js"
export * from "./Nopassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__